import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';

import * as TnaOrderTemplateActions from './tna-order-template.actions';
import * as TnaOrderTemplateSelectors from './tna-order-template.selectors';
import { TPlani8State } from '../reducers';
import { TLiftedFormModel } from '@monorepo/ui';
import { TREQUEST_AUTO_UPDATE_TARGET_DATES, TREQUEST_UPDATE_STEP_BY_TEMPLATE_ID } from '@monorepo/types';

@Injectable({
  providedIn: 'root',
})
export class TnAOrderTemplateFacade {
  constructor(private store: Store<TPlani8State>) {}

  setShowTnAOrderTemplatesLoader(showLoader: boolean) {
    this.store.dispatch(new TnaOrderTemplateActions.SetShowTnAOrderTemplatesLoader(showLoader));
  }

  fetchTnAOrderTemplates(tnaOrderTemplateId: string, showLocalLoader?: boolean) {
    this.store.dispatch(new TnaOrderTemplateActions.GetTnAOrderTemplates(tnaOrderTemplateId, showLocalLoader));
  }

  clearTnAOrderTemplatesInfo() {
    this.store.dispatch(new TnaOrderTemplateActions.ClearTnAOrderTemplates());
  }

  autoUpdateTargetDates(payload: TREQUEST_AUTO_UPDATE_TARGET_DATES, orderTnaId: string) {
    this.store.dispatch(new TnaOrderTemplateActions.AutoUpdateTargetDates(payload, orderTnaId));
  }

  addUpdateTnAOrderTemplateStep(tnaOrderTemplateUpdateStepReq: TLiftedFormModel['payload']) {
    this.store.dispatch(new TnaOrderTemplateActions.AddUpdateTnAOrderTemplate(tnaOrderTemplateUpdateStepReq));
  }

  deleteTnAOrderTemplateStep(tnaOrderTemplateDeleteReq: TLiftedFormModel['payload']) {
    this.store.dispatch(new TnaOrderTemplateActions.DeleteTnAOrderTemplate(tnaOrderTemplateDeleteReq));
  }

  updateStepByTemplateId(payload: TREQUEST_UPDATE_STEP_BY_TEMPLATE_ID, orderTnaId: string) {
    this.store.dispatch(new TnaOrderTemplateActions.UpdateStepByTemplateId(payload, orderTnaId));
  }

  getTnAOrderTemplatesInfo() {
    return this.store.pipe(select(TnaOrderTemplateSelectors.getTnAOrdertemplatesInfo));
  }

  getShowTnAOrderTemplatesLoader() {
    return this.store.pipe(select(TnaOrderTemplateSelectors.getShowTnAOrderTemplatesLoader));
  }

  downloadTnAOrderTemplate(templateId: string) {
    this.store.dispatch(new TnaOrderTemplateActions.DownloadTnaOrderTemplate(templateId));
  }
}
